const MtrTrash2Outline={
    "name": "mtr-trash2",
    "theme": "outline",
    "icon": {
        "tag": "svg",
        "attrs": {
            "fill": "none",
            "stroke": "currentColor",
            "stroke-linecap": "round",
            "stroke-linejoin": "round",
            "stroke-width": "2",
            "viewBox": "0 0 24 24"
        },
        "children": [
            {
                "tag": "polyline",
                "attrs": {
                    "points": "3 6 5 6 21 6"
                }
            },
            {
                "tag": "path",
                "attrs": {
                    "d": "M19 6v14a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V6m3 0V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2"
                }
            }
        ]
    }
};
export default MtrTrash2Outline;